import React, {PureComponent} from 'react';
import LazyLoad from '../../common/lazy-image/react-lazyload/index';

// TODO: get key for width 270px
const resolutions = [
    {key: 'xs', value: '(max-width: 767px)'}, // 302px
    {key: 'm', value: '(min-width: 768px)'} // 338px
];

function createSource(mkSrc) {
    return ({key, value}) => (
        <source
            key={key}
            media={value}
            srcSet={mkSrc(key)}
        />
    );
}

function placeholderImage(altText) {
    return (
        <div
            className="carousel__image__placeholder"
            alt={altText}
        />
    );
}

function renderImage(baseClass, altText, mkSrc) {
    const defaultSrc = mkSrc('m');

    if (!defaultSrc) {
        return null;
    }

    const className = `${baseClass}__image`;
    const sources = resolutions.map(createSource(mkSrc));
    const placeholder = placeholderImage(altText);

    return (
        <LazyLoad once offset={300} placeholder={placeholder} >
            <picture>
                {sources}
                <img className={className} src={defaultSrc} alt={altText} />
            </picture>
        </LazyLoad>
    );
}

export class CarouselCard extends PureComponent {
    render() {
        const {
            baseClass,
            mkSrc,
            path,
            linkRel,
            title,
            subtitle,
            altText,
            footer,
            onClick
        } = this.props;

        const link = {
            href: path,
            rel: linkRel
        };

        const image = renderImage(baseClass, altText, mkSrc);

        return (
            <a {...link} className={baseClass} onClick={onClick}>
                {image}

                <div className={`${baseClass}__overlay`} />
                <div className={`${baseClass}__content`}>
                    <h2 className={`${baseClass}__title`}>{title}</h2>
                    <h3 className={`${baseClass}__subtitle`}>{subtitle}</h3>
                    <div className={`${baseClass}__footer`}>
                        <p className={`${baseClass}__footer-label`}>{footer}</p>
                    </div>
                </div>
            </a>
        );
    }
}

